import {createConsumer as actualCreateConsumer} from '@rails/actioncable'

import {API_BASE_URL} from '../api/chatApi'

/**
 * Constructs WebSocket URL for Action Cable
 * Uses relative path approach like GraphQL:
 * - Development: Uses current window location (proxied via setupProxy.js)
 * - Production: Uses current window location (same origin)
 *
 * Action Cable requires the /cable endpoint, which is configured in Rails
 * config.action_cable.url = "/cable"
 */
const getWebSocketUrl = () => {
  // If API_BASE_URL is empty (relative path), use current window location
  if (!API_BASE_URL || API_BASE_URL === '') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    let host = window.location.host
    // In development, if host is localhost:3000 (React dev server), use localhost:3001 (Rails backend)
    if (host === 'localhost:3000') {
      host = 'localhost:3001'
    }
    console.log('host', host)
    // Action Cable endpoint is always /cable
    return `${protocol}//${host}/cable`
  }

  // Fallback for absolute URLs (shouldn't be needed with relative path approach)
  if (API_BASE_URL.startsWith('https')) {
    return API_BASE_URL.replace('https://', 'wss://') + '/cable'
  } else {
    return API_BASE_URL.replace('http://', 'ws://') + '/cable'
  }
}

export const consumer = (pid) =>
  actualCreateConsumer(`${getWebSocketUrl()}?pid=${pid}`)
